import React from 'react';
import { useState } from 'react';
import { useToast } from '../hooks/useToast';
import { Link } from 'react-router-dom';
import { authService } from '../api';
import { AuthPageShell } from '../components/ui/AuthPageShell';
import { AppButton } from '../components/ui/AppButton';
import { getEmailValidationError } from '../utils/emailValidation';

export function ForgotPasswordPage() {
  const { showToast } = useToast();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const submit = async () => {
    if (!email.trim()) {
      showToast('Enter your email', 'error');
      return;
    }
    const emailError = getEmailValidationError(email);
    if (emailError) {
      showToast(emailError, 'error');
      return;
    }
    setLoading(true);
    try {
      await authService.forgotPassword({
        email,
      });
      showToast('If the account exists, a reset email has been sent.', 'success');
    } catch (e) {
      showToast(e instanceof Error ? e.message : 'Failed to request reset', 'error');
    } finally {
      setLoading(false);
    }
  };
  const inputClass =
    'w-full min-h-[44px] px-4 py-3 border border-slate-300 rounded-xl bg-white text-slate-900 transition-shadow duration-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-400';

  return (
    <AuthPageShell
      title="Forgot Password"
      description="Enter your email and we'll send a password reset link."
    >
      <div className="space-y-4">
        <div>
          <label className="mb-2 block text-sm font-bold text-slate-700">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={inputClass}
            autoComplete="email"
          />
        </div>
        <AppButton
          type="button"
          variant="primary"
          size="lg"
          fullWidth
          disabled={loading}
          onClick={() => void submit()}
        >
          {loading ? 'Sending…' : 'Send Reset Link'}
        </AppButton>
        <div className="text-sm">
          <Link
            to="/login"
            className="font-bold text-indigo-600 transition-colors hover:text-indigo-800"
          >
            Back to login
          </Link>
        </div>
      </div>
    </AuthPageShell>
  );
}
